module.exports = __webpack_public_path__ + "static/17.1_Renaissance-9e2e3b23e3b84d67fb67af9e564190ac.pdf";